<!-- Overlay backdrop -->
<div class="drawer-backdrop" *ngIf="isOpen" (click)="close()"></div>

<!-- Drawer panel -->
<aside class="policy-drawer" [class.policy-drawer--open]="isOpen"
       role="dialog" aria-label="Existing policy details">

  <!-- Drawer header -->
  <div class="drawer-header">
    <div class="drawer-title-group">
      <mat-icon class="drawer-type-icon">
        {{ displayResourceType === 'Vm' ? 'computer' : 'manage_accounts' }}
      </mat-icon>
      <div>
        <h2 class="drawer-title">{{ displayPolicyName }}</h2>
        <span class="drawer-badge"
              [class.drawer-badge--vm]="displayResourceType === 'Vm'"
              [class.drawer-badge--ua]="displayResourceType === 'UserAccount'">
          {{ displayResourceType === 'Vm' ? 'VM Policy' : 'User Account Policy' }}
        </span>
      </div>
    </div>
    <button mat-icon-button (click)="close()" aria-label="Close drawer">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-divider></mat-divider>

  <!-- Loading state -->
  <div class="drawer-loading" *ngIf="isLoading">
    <mat-spinner diameter="36"></mat-spinner>
    <p>Loading policy details…</p>
  </div>

  <!-- Detail content -->
  <div class="drawer-content" *ngIf="detail && !isLoading">

    <p class="drawer-description" *ngIf="detail.description">{{ detail.description }}</p>
    <p class="drawer-description drawer-description--empty" *ngIf="!detail.description">
      No description provided.
    </p>

    <mat-accordion [multi]="true">

      <!-- Resource Creation -->
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon>add_circle_outline</mat-icon>&nbsp;Resource Creation
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p><strong>Mode:</strong> On Demand</p>
      </mat-expansion-panel>

      <!-- VM-specific steps -->
      <ng-container *ngIf="detail.resourceType === 'Vm' && detail.vmSteps">

        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title><mat-icon>today</mat-icon>&nbsp;Daily Resource Cleanup</mat-panel-title>
          </mat-expansion-panel-header>
          <p>{{ formatVmCleanup(detail.vmSteps!.dailyCleanup) }}</p>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title><mat-icon>event_available</mat-icon>&nbsp;Class End Cleanup</mat-panel-title>
          </mat-expansion-panel-header>
          <p>{{ formatVmCleanup(detail.vmSteps!.classEndCleanup) }}</p>
        </mat-expansion-panel>

      </ng-container>

      <!-- UA-specific steps -->
      <ng-container *ngIf="detail.resourceType === 'UserAccount' && detail.uaSteps">

        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title><mat-icon>today</mat-icon>&nbsp;Daily Resource Cleanup</mat-panel-title>
          </mat-expansion-panel-header>
          <p>{{ formatUaCleanup(detail.uaSteps!.dailyCleanup) }}</p>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title><mat-icon>event_available</mat-icon>&nbsp;Class End Cleanup</mat-panel-title>
          </mat-expansion-panel-header>
          <p>{{ formatUaCleanup(detail.uaSteps!.classEndCleanup) }}</p>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title><mat-icon>speed</mat-icon>&nbsp;Quota Limit Policy</mat-panel-title>
          </mat-expansion-panel-header>
          <ng-container *ngIf="detail.uaSteps!.quotaLimit; else noQuota">
            <div class="quota-row">
              <div class="quota-stat">
                <span class="quota-stat-label">Budget Threshold</span>
                <span class="quota-stat-value">₹{{ detail.uaSteps!.quotaLimit!.thresholdAmount | number }}</span>
              </div>
              <div class="quota-stat" *ngIf="detail.uaSteps!.quotaLimit!.action.actionType === 'ExtendQuota'">
                <span class="quota-stat-label">Extension Amount</span>
                <span class="quota-stat-value">₹{{ $any(detail.uaSteps!.quotaLimit!.action).additionalAmount | number }}</span>
              </div>
              <div class="quota-stat">
                <span class="quota-stat-label">Action at 100%</span>
                <span class="quota-stat-value" style="font-size: 0.82rem; font-weight: 500; color: #333">
                  {{ formatQuotaAction(detail.uaSteps!.quotaLimit!.action) }}
                </span>
              </div>
            </div>

            <!-- Notification bands -->
            <ng-container *ngIf="detail.uaSteps!.quotaLimit!.notificationBands?.length">
              <div class="bands-section-label">Notification Bands</div>
              <div *ngFor="let band of detail.uaSteps!.quotaLimit!.notificationBands"
                   class="band-row"
                   [class.band-row--fixed]="band.triggerPercentage === 100">
                <div class="band-row-header">
                  <span class="band-percent-badge"
                        [class.band-percent-badge--fixed]="band.triggerPercentage === 100">
                    {{ band.triggerPercentage }}%
                  </span>
                  <span style="font-size: 0.82rem; color: rgba(0,0,0,0.54)">
                    {{ band.triggerPercentage === 100 ? 'Budget fully consumed' : 'of budget spent' }}
                  </span>
                </div>
                <div class="band-notif-rows" *ngIf="band.notifications?.length; else noNotifs">
                  <div *ngFor="let n of band.notifications" class="band-notif-item">
                    <mat-icon style="font-size: 15px; width: 15px; height: 15px;">groups</mat-icon>
                    <span>{{ n.teamName }}</span>
                    <span *ngIf="n.userIds?.length" style="color: rgba(0,0,0,0.45); font-size: 0.75rem">
                      ({{ n.userIds.length }} user{{ n.userIds.length !== 1 ? 's' : '' }})
                    </span>
                    <div class="band-notif-channels">
                      <span *ngFor="let ch of n.channels" class="band-channel-chip">{{ ch }}</span>
                    </div>
                  </div>
                </div>
                <ng-template #noNotifs>
                  <p style="font-size: 0.78rem; color: rgba(0,0,0,0.45); margin: 4px 0 0; font-style: italic">
                    No team notifications configured.
                  </p>
                </ng-template>
              </div>
            </ng-container>

          </ng-container>
          <ng-template #noQuota><p style="color: rgba(0,0,0,0.54); font-size: 0.85rem">Not configured — no budget cap enforced.</p></ng-template>
        </mat-expansion-panel>

      </ng-container>

    </mat-accordion>

    <!-- Footer metadata -->
    <div class="drawer-footer">
      <mat-divider></mat-divider>
      <p class="drawer-meta">
        <mat-icon class="meta-icon">fingerprint</mat-icon>
        <span class="mono">{{ detail.contentHash }}</span>
      </p>
      <p class="drawer-meta">
        <mat-icon class="meta-icon">schedule</mat-icon>
        Created {{ detail.createdAt | date:'dd MMM yyyy' }}
      </p>
    </div>

  </div>

</aside>
